import Swal from "sweetalert2";

function processErrors(response) {
    if (!response) {
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong, Type 1",
        });
        return false;
    }

    if (!response.data) {
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.message || "Something went wrong, Type 2",
        });
        return false;
    }

    let object = {};
    let title = "Oops...";
    let msgList = "";

    const errors = response.data?.errors;

    if (errors) {
        if (Array.isArray(errors)) {
            object = errors;
            msgList = errors
                .map((error) => `<li>${error?.toString() || ""}</li>`)
                .join("");
        } else if (typeof errors === "object" && errors !== null) {
            for (const [key, value] of Object.entries(errors)) {
                if (Array.isArray(value) && value.length > 0) {
                    object[key] = value[0];
                    msgList += `<li>${value[0]}</li>`;
                } else if (typeof value === "object" && value !== null) {
                    for (const [key2, value2] of Object.entries(value)) {
                        object[key2] = value2;
                        msgList += `<li>${value2}</li>`;
                    }
                } else {
                    object[key] = value;
                    msgList += `<li>${value?.toString() || ""}</li>`;
                }
            }
        }
    } else {
        msgList = `<li>${response.message || "Unknown error"}</li>`;
    }

    Swal.fire({
        icon: "error",
        title: title,
        html: msgList ? `<ul>${msgList}</ul>` : "Unknown error",
    });

    return object;
}

export default processErrors;
